{
    "NextrunningatLabel": "Nächster Lauf um:",
    "LastrunatLabel": "Zuletzt ausgeführt um:",
    "StatuserrorLabel": "Status \/ Fehler:",
    "ScheduleStatus_SectionHeader": "Planungsstatus",
    "NAME": "ScheduleStatus"
}